import * as yup from "yup";
import { usuarioSchema } from "./usuarioSchema";

export const autocadastroSchema = usuarioSchema.shape({
  senha: yup.string().required("A senha é obrigatória").min(6, "A senha deve ter no mínimo 6 caracteres"),
  confirmacaoSenha: yup
    .string()
    .required("A confirmação de senha é obrigatória")
    .oneOf([yup.ref("senha")], "As senhas não coincidem"),
});
